import { createContext, MutableRefObject } from 'react';

/**
 * Context providing the current scrollable content element where its children
 * are. For example, it can prove useful when a component wants to scroll its
 * children content to the top.
 */
export const ScrollContext =
  createContext<MutableRefObject<HTMLElement | null> | null>(null);
